<i18n>
{
  "en": {
    "plan": {
      "free": "You will get the Free license (only 10 contacts converted)",
      "month": "You will get the 30 days license (unlimitted contacts & conversions)",
      "lifetime": "You will get the Lifetime license (unlimitted contacts & conversions)"
    },
    "placeholders": {
      "email": "E-mail",
      "password": "Password"
    },
    "cta": "Create my account"
  }
}
</i18n>

<script>
import { signup } from '@/config/auth';

export default {
  props: {
    plan: {
      type: String,
      default: 'free',
    },
  },

  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
    };
  },

  methods: {
    signup() {
      this.isLoading = true;

      signup({
        email: this.email,
        password: this.password,
        plan: this.plan,
      })
        .then(() => {
          this.$emit('complete');
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$addMessage(error.message, 'danger');
          this.$trackError(error);
        });
    },
  },

  created() {
    this.$trackPageView('Signup', '/modal/signup');
  },
};
</script>

<template>
  <form @submit.prevent="signup">
    <p class="fsize-5 text-center color-main" v-t="`plan.${plan}`" />
    <p class="mt-3">
      <label for="email" v-t="'placeholders.email'" />
      <input class="input" type="email" id="email" v-model="email" required>
    </p>
    <p class="mt-3">
      <label for="password" v-t="'placeholders.password'" />
      <input class="input" type="password" id="password" v-model="password" required>
    </p>
    <p v-show="isLoading" class="text-center mt-2 fsize-5 color-main" v-t="'loading'" />
    <p class="mt-3 text-center">
      <button type="submit" class="btn" v-t="'cta'" :disabled="isLoading" />
    </p>
  </form>
</template>
